import { memo } from "react";
import Page from "components/page/Page";
import { Helmet } from "react-helmet";
import Card from "components/card/Card";
import { Link } from "react-router-dom";
import { styled } from "styled-components";
import { PageCollapseWidth } from "../../constants";

const ToolSection = styled.div`
  margin-bottom: 2rem;
`;

const ToolTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 0.5rem;

  a {
    color: var(--primary-color);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const ToolDescription = styled.p`
  margin-bottom: 0.5rem;
  color: var(--bs-body-color);
`;

const UrlPage = () => {
  return (
    <>
      <Helmet>
        <title>URL Tools – Encode and Decode URLs | ToolWeaver</title>
        <meta
          name="description"
          content="Free online URL tools. Encode text for use in URLs or decode URL-encoded strings instantly. Your input is processed to produce the result and is not stored."
        />
        <link rel="canonical" href="https://toolweaver.com/url" />
      </Helmet>
      <Page>
        <Card collapseOnWidth={PageCollapseWidth} title="URL Tools">
          <span className="d-block mb-4">
            URL encoding converts characters into a format that can be safely
            transmitted over the internet. Use our free tools to encode or
            decode URL data instantly.
          </span>

          <ToolSection>
            <ToolTitle>
              <Link to="/urlencode">URL Encoder</Link>
            </ToolTitle>
            <ToolDescription>
              Convert text into URL-safe encoded format. Encode special
              characters for use in URLs and query strings.
            </ToolDescription>
          </ToolSection>

          <ToolSection>
            <ToolTitle>
              <Link to="/urldecode">URL Decoder</Link>
            </ToolTitle>
            <ToolDescription>
              Decode URL-encoded text back to readable format. Instantly convert
              percent-encoded strings to plain text.
            </ToolDescription>
          </ToolSection>
        </Card>
      </Page>
    </>
  );
};

export default memo(UrlPage);
